<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="150"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="150"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="150"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " boxShadowH",
          describe: "X轴偏移量",
          type: "String/Number/Array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " boxShadowV",
          describe: "y轴偏移量",
          type: "String/Number/Array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " boxShadowBlur",
          describe: "模糊值",
          type: "String/Number/Array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " boxShadowSpread",
          describe: "扩散值",
          type: "String/Number/Array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " boxShadowColor",
          describe: "阴影颜色",
          type: "String/Array",
          Option: "-",
          default: "-",
          required: "true"
        }
      ]
    }
  }
}
</script>

<style></style>
